import JockeyNameRow from './JockeyNameRow';
import OwnerNameRow from './OwnerNameRow';
import TrainerNameRow from './TrainerNameRow';

export default {
    jockey: JockeyNameRow,
    owner: OwnerNameRow,
    trainer: TrainerNameRow,
};



// WEBPACK FOOTER //
// ./src/js/human/nameRow/index.js